export const MODAL_OPEN = 'MODAL_OPEN';
export const MODAL_TOGGLE = 'MODAL_TOGGLE';
export const MODAL_CLOSE = 'MODAL_CLOSE';

export const REHYDRATE_STORE_REQUEST = 'REHYDRATE_STORE_REQUEST';
export const REHYDRATE_STORE = 'REHYDRATE_STORE';

export const SELECT_CITY = 'SELECT_CITY';
export const SELECT_CITY_REQUEST = 'SELECT_CITY_REQUEST';
export const SELECT_CITY_DEFAULT = 'SELECT_CITY_DEFAULT';
export const SELECT_CITY_DEFAULT_REQUEST = 'SELECT_CITY_DEFAULT_REQUEST';

export const SELECT_DATE = 'SELECT_DATE';
export const SELECT_DATE_REQUEST = 'SELECT_DATE_REQUEST';
export const SELECT_DATE_DEFAULT = 'SELECT_DATE_DEFAULT';
export const SELECT_DATE_DEFAULT_REQUEST = 'SELECT_DATE_DEFAULT_REQUEST';

export const SELECT_GUEST_AMOUNT = 'SELECT_GUEST_AMOUNT';
export const SELECT_GUEST_AMOUNT_REQUEST = 'SELECT_GUEST_AMOUNT_REQUEST';
export const SELECT_GUEST_AMOUNT_DEFAULT = 'SELECT_GUEST_AMOUNT_DEFAULT';
export const SELECT_GUEST_AMOUNT_DEFAULT_REQUEST = 'SELECT_GUEST_AMOUNT_DEFAULT_REQUEST';

export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SELECT_PRODUCT_REQUEST = 'SELECT_PRODUCT_REQUEST';
export const SELECT_PRODUCT_DEFAULT = 'SELECT_PRODUCT_DEFAULT';
export const SELECT_PRODUCT_DEFAULT_REQUEST = 'SELECT_PRODUCT_DEFAULT_REQUEST';

export const SELECT_SORT_TYPE = 'SELECT_SORT_TYPE';
export const SELECT_SORT_TYPE_REQUEST = 'SELECT_SORT_TYPE_REQUEST';
export const SELECT_SORT_TYPE_DEFAULT = 'SELECT_SORT_TYPE_DEFAULT';
export const SELECT_SORT_TYPE_DEFAULT_REQUEST = 'SELECT_SORT_TYPE_DEFAULT_REQUEST';

export const SELECT_DISTANCE = 'SELECT_DISTANCE';
export const SELECT_DISTANCE_REQUEST = 'SELECT_DISTANCE_REQUEST';
export const SELECT_DISTANCE_DEFAULT = 'SELECT_DISTANCE_DEFAULT';
export const SELECT_DISTANCE_DEFAULT_REQUEST = 'SELECT_DISTANCE_DEFAULT_REQUEST';

export const SELECT_PRICE = 'SELECT_PRICE';
export const SELECT_PRICE_REQUEST = 'SELECT_PRICE_REQUEST';
export const SELECT_PRICE_DEFAULT = 'SELECT_PRICE_DEFAULT';
export const SELECT_PRICE_DEFAULT_REQUEST = 'SELECT_PRICE_DEFAULT_REQUEST';

export const SELECT_EXPERIENCE = 'SELECT_EXPERIENCE';
export const SELECT_EXPERIENCE_REQUEST = 'SELECT_EXPERIENCE_REQUEST';
export const SELECT_EXPERIENCE_DEFAULT = 'SELECT_EXPERIENCE_DEFAULT';
export const SELECT_EXPERIENCE_DEFAULT_REQUEST = 'SELECT_EXPERIENCE_DEFAULT_REQUEST';

export const SOCIAL_REQUEST = 'SOCIAL_REQUEST';
export const SOCIAL_SUCCESS = 'SOCIAL_SUCCESS';
export const SOCIAL_FAILURE = 'SOCIAL_FAILURE';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

export const RETRIEVE_PASSWORD_REQUEST = 'RETRIEVE_PASSWORD_REQUEST';
export const RETRIEVE_PASSWORD_SUCCESS = 'RETRIEVE_PASSWORD_SUCCESS';
export const RETRIEVE_PASSWORD_FAILURE = 'RETRIEVE_PASSWORD_FAILURE';
export const RETRIEVE_PASSWORD_RESET = 'RETRIEVE_PASSWORD_RESET';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const DEFINE_USER_COORDINATES_REQUEST = 'DEFINE_USER_COORDINATES_REQUEST';
export const DEFINE_USER_COORDINATES_SUCCESS = 'DEFINE_USER_COORDINATES_SUCCESS';
export const DEFINE_USER_COORDINATES_FAILURE = 'DEFINE_USER_COORDINATES_FAILURE';

export const UPLOAD_AVATAR_REQUEST = 'UPLOAD_AVATAR_REQUEST';
export const UPLOAD_AVATAR_SUCCESS = 'UPLOAD_AVATAR_SUCCESS';
export const UPLOAD_AVATAR_FAILURE = 'UPLOAD_AVATAR_FAILURE';

export const REMOVE_AVATAR_REQUEST = 'REMOVE_AVATAR_REQUEST';
export const REMOVE_AVATAR_SUCCESS = 'REMOVE_AVATAR_SUCCESS';
export const REMOVE_AVATAR_FAILURE = 'REMOVE_AVATAR_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';

export const UPDATE_SUGGESTIONS = 'UPDATE_SUGGESTIONS';

export const SET_UP_USER_PRODUCT = 'SET_UP_USER_PRODUCT';

export const REHYDRATE_USER_SESSION = 'REHYDRATE_USER_SESSION';
export const REHYDRATE_USER_BOOKING = 'REHYDRATE_USER_BOOKING';

export const SET_UP_USER_HOTEL = 'SET_UP_USER_HOTEL';

export const UPDATE_USER_PRODUCT_PRICE_REQUEST = 'UPDATE_USER_PRODUCT_PRICE_REQUEST';
export const UPDATE_USER_PRODUCT_PRICE_SUCCESS = 'UPDATE_USER_PRODUCT_PRICE_SUCCESS';
export const UPDATE_USER_PRODUCT_PRICE_FAILURE = 'UPDATE_USER_PRODUCT_PRICE_FAILURE';

export const UPDATE_USER_PRODUCT_REQUEST = 'UPDATE_USER_PRODUCT_REQUEST';
export const UPDATE_USER_PRODUCT_SUCCESS = 'UPDATE_USER_PRODUCT_SUCCESS';
export const UPDATE_USER_PRODUCT_REMOVE_PROMO = 'UPDATE_USER_PRODUCT_REMOVE_PROMO';

export const SELECT_PAYMENT_METHOD = 'SELECT_PAYMENT_METHOD';

export const CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS = 'CHECKOUT_PAYMENT_TOGGLE_USE_CREDITS';
export const CHECKOUT_PAYMENT_USE_CREDITS = 'CHECKOUT_PAYMENT_USE_CREDITS';
export const CHECKOUT_PAYMENT_NOT_USE_CREDITS = 'CHECKOUT_PAYMENT_NOT_USE_CREDITS';

export const CHECKOUT_PAYMENT_RESET = 'CHECKOUT_PAYMENT_RESET';
export const CHECKOUT_PAYMENT_REQUEST = 'CHECKOUT_PAYMENT_REQUEST';
export const CHECKOUT_PAYMENT_SET_FETCH = 'CHECKOUT_PAYMENT_SET_FETCH';
export const CHECKOUT_PAYMENT_SUCCESS = 'CHECKOUT_PAYMENT_SUCCESS';
export const CHECKOUT_PAYMENT_ALREADY_BOOKED = 'CHECKOUT_PAYMENT_ALREADY_BOOKED';

export const CHECKOUT_PAYMENT_FAILURE = 'CHECKOUT_PAYMENT_FAILURE';
export const CHECKOUT_PAYMENT_HAS_ACCOUNT = 'CHECKOUT_PAYMENT_HAS_ACCOUNT';
export const CHECKOUT_PAYMENT_REDIRECTED = 'CHECKOUT_PAYMENT_REDIRECTED';
export const CHECKOUT_PAYMENT_FREE = 'CHECKOUT_PAYMENT_FREE';
export const CHECKOUT_PAYMENT_FREE_FAILURE = 'CHECKOUT_PAYMENT_FREE_FAILURE';

export const CHECKOUT_HOTEL_SUCCESS = 'CHECKOUT_HOTEL_SUCCESS';
export const CHECKOUT_GIFT_SUCCESS = 'CHECKOUT_GIFT_SUCCESS';
export const CHECKOUT_PASS_SUCCESS = 'CHECKOUT_PASS_SUCCESS';

export const CHECK_PROMO_CODE_REQUEST = 'CHECK_PROMO_CODE_REQUEST';
export const CHECK_PROMO_CODE_SUCCESS = 'CHECK_PROMO_CODE_SUCCESS';
export const CHECK_PROMO_CODE_FAILURE = 'CHECK_PROMO_CODE_FAILURE';
export const CHECK_PROMO_CODE_RESET = 'CHECK_PROMO_CODE_RESET';
export const CHECK_PROMO_CODE_INITIAL = 'CHECK_PROMO_CODE_INITIAL';

export const VALIDATION_START = 'VALIDATION_START';
export const VALIDATION_ABORT = 'VALIDATION_ABORT';
export const VALIDATION_REQUEST = 'VALIDATION_REQUEST';
export const VALIDATION_SUCCESS = 'VALIDATION_SUCCESS';
export const VALIDATION_FAILURE = 'VALIDATION_FAILURE';
export const VALIDATION_DATE_CHECK_FAILURE = 'VALIDATION_DATE_CHECK_FAILURE';

export const EMAIL_SUBSCRIPTION_REQUEST = 'EMAIL_SUBSCRIPTION_REQUEST';
export const EMAIL_SUBSCRIPTION_SUCCESS = 'EMAIL_SUBSCRIPTION_SUCCESS';
export const EMAIL_SUBSCRIPTION_FAILURE = 'EMAIL_SUBSCRIPTION_FAILURE';

export const EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST = 'EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_REQUEST';
export const EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_SUCCESS = 'EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_SUCCESS';
export const EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_FAILURE = 'EMAIL_SUBSCRIPTION_TO_SPOT_OPEN_ALERT_FAILURE';

export const SHARE_WITH_FRIEND_REQUEST = 'SHARE_WITH_FRIEND_REQUEST';
export const SHARE_WITH_FRIEND_SUCCESS = 'SHARE_WITH_FRIEND_SUCCESS';
export const SHARE_WITH_FRIEND_FAILURE = 'SHARE_WITH_FRIEND_FAILURE';

export const BOOKING_MANAGEMENT_PROCESS_INIT = 'BOOKING_MANAGEMENT_PROCESS_INIT';
export const CHANGING_CHECKING_DATE_INIT = 'CHANGING_CHECKING_DATE_INIT';
export const CHANGING_CHECKING_DATE_SUCCESS = 'CHANGING_CHECKING_DATE_SUCCESS';
export const CHANGING_CHECKING_DATE_FAILURE = 'CHANGING_CHECKING_DATE_FAILURE';
export const CHANGING_CHECKING_DATE_DEFAULT = 'CHANGING_CHECKING_DATE_FAILURE';

export const HOTEL_REVIEW_PROCESS_REQUEST = 'HOTEL_REVIEW_PROCESS_REQUEST';
export const HOTEL_REVIEW_PROCESS_SUCCESS = 'HOTEL_REVIEW_PROCESS_SUCCESS';
export const HOTEL_REVIEW_PROCESS_FAILURE = 'HOTEL_REVIEW_PROCESS_FAILURE';

export const CANCEL_TICKET_REQUEST = 'CANCEL_TICKET_REQUEST';
export const CANCEL_TICKET_SUCCESS = 'CANCEL_TICKET_SUCCESS';
export const CANCEL_TICKET_FAILURE = 'CANCEL_TICKET_FAILURE';

export const CHANGE_CHECKIN_DATE_REQUEST = 'CHANGE_CHECKIN_DATE_REQUEST';
export const CHANGE_CHECKIN_DATE_SUCCESS = 'CHANGE_CHECKIN_DATE_SUCCESS';
export const CHANGE_CHECKIN_DATE_REMOVE_ERRORS = 'CHANGE_CHECKIN_DATE_REMOVE_ERRORS';
export const CHANGE_CHECKIN_DATE_FAILURE = 'CHANGE_CHECKIN_DATE_FAILURE';

export const CHANGE_BOOKING_STATUS = 'CHANGE_BOOKING_STATUS';

export const SEGMENT_REQUEST = 'SEGMENT_REQUEST';
export const SEGMENT_REQUEST_SUCCESS = 'SEGMENT_REQUEST_SUCCESS';
export const SEGMENT_REQUEST_FAILURE = 'SEGMENT_REQUEST_FAILURE';

export const CANCEL_SUBSCRIPTION_REQUEST = 'CANCEL_SUBSCRIPTION_REQUEST';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
export const CANCEL_SUBSCRIPTION_FAILURE = 'CANCEL_SUBSCRIPTION_FAILURE';

export const ADD_CREDIT_REQUEST = 'ADD_CREDIT_REQUEST';
export const ADD_CREDIT_SUCCESS = 'ADD_CREDIT_SUCCESS';
export const ADD_CREDIT_FAILURE = 'ADD_CREDIT_FAILURE';

export const FETCH_USER_CARDS_REQUEST = 'FETCH_USER_CARDS_REQUEST';
export const FETCH_USER_CARDS_SUCCESS = 'FETCH_USER_CARDS_SUCCESS';
export const FETCH_USER_CARDS_FAILURE = 'FETCH_USER_CARDS_FAILURE';

export const OPEN_CHECKOUT_ITEM_PAGE = 'OPEN_CHECKOUT_ITEM_PAGE';
export const OPEN_CHECKOUT_GIFT_PAGE = 'OPEN_CHECKOUT_GIFT_PAGE';
export const OPEN_CHECKOUT_SUBSCRIPTION_PAGE = 'OPEN_CHECKOUT_SUBSCRIPTION_PAGE';
export const OPEN_PRODUCT_PAGE = 'OPEN_PRODUCT_PAGE';
export const OPEN_SEARCH_PAGE = 'OPEN_SEARCH_PAGE';

export const CREATE_CONTACT_ADD_TO_LIST = 'CREATE_CONTACT_ADD_TO_LIST';
export const CREATE_CONTACT_ADD_TO_LIST_SUCCESS = 'CREATE_CONTACT_ADD_TO_LIST_SUCCESS';
export const CREATE_CONTACT_ADD_TO_LIST_FAILURE = 'CREATE_CONTACT_ADD_TO_LIST_FAILURE';
export const CLEAR_ACTIVECAMPAIGN = 'CLEAR_ACTIVECAMPAIGN'
export const CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER = 'CREATE_CONTACT_ADD_TO_LIST_FROM_FOOTER'; 
export const CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER = 'CREATE_CONTACT_ADD_TO_LIST_SUCCESS_FROM_FOOTER'; 
export const CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER = 'CREATE_CONTACT_ADD_TO_LIST_FAILURE_FROM_FOOTER';